export * from './scrollTo.module';
export * from './scrollTo.service';
export * from './scrollTo.directive';
//# sourceMappingURL=index.js.map